export { default as WindowEvents } from './WindowEvents.js';
export { default as LockScroll } from './LockScroll.js';
export { default as Slider } from './Slider.js';
export { default as SliderText } from './SliderText.js';
export { default as YoutubeVideo } from './YoutubeVideo.js';
export { default as BlockquoteSlider } from './BlockquoteSlider.js';
export { default as FixedHeader } from './FixedHeader.js';
export { default as Menu } from './Menu.js';
export { default as FixedAnchor } from './FixedAnchor.js';
export { default as Accordeon } from './Accordeon.js';
export { default as Filter } from './Filter.js';
export { default as Disclaimer } from './Disclaimer.js';
export { default as TabFocus } from './TabFocus.js';
export { default as Anchor } from './Anchor.js';
export { default as ScrollbarWidthChecker } from './ScrollbarWidthChecker.js';
export { default as Search } from './Search.js';
export { default as Subscribe } from './Subscribe.js';
export { default as Validate } from './Validate.js';

export { default as Preloader } from './Preloader.js';   // Подключается последним



// WEBPACK FOOTER //
// ./_src/js/modules/index.js